import React from "react";
import PieChart from "../../charts/PieChart";

import { tailwindConfig } from "../../utils/Utils";
import { toMoneyFormat } from "utils";
import { PaziaBox } from "components/atoms";
import { useCourseFinancesByCategory } from "api/course-finances";

interface BalancePieChartProps {
  courseId: number;
  className?: string;
  headerLink?: string;
  onAdd?: () => void;
}
export const BalancePieChart = ({ courseId, onAdd, headerLink, className = "" }: BalancePieChartProps) => {
  const { loading, data } = useCourseFinancesByCategory(courseId);

  if (!data) return null; // TODO Skeleton
  const labels = data?.groups.map((item) => item.name) || [];
  const values = data?.groups.map((item) => item.balance) || [];

  const chartData = {
    labels,
    datasets: [
      {
        label: "Łączny bilans grupy",
        data: values,
        backgroundColor: [
          tailwindConfig().theme.colors.emerald[400],
          tailwindConfig().theme.colors.amber[400],
          tailwindConfig().theme.colors.sky[400],
          tailwindConfig().theme.colors.indigo[500],
          tailwindConfig().theme.colors.red[500],
          tailwindConfig().theme.colors.orange[500],
          tailwindConfig().theme.colors.lime[500],
          tailwindConfig().theme.colors.sky[500],
        ],
        hoverBackgroundColor: [
          tailwindConfig().theme.colors.emerald[500],
          tailwindConfig().theme.colors.amber[500],
          tailwindConfig().theme.colors.sky[500],
          tailwindConfig().theme.colors.indigo[600],
          tailwindConfig().theme.colors.red[600],
          tailwindConfig().theme.colors.orange[600],
          tailwindConfig().theme.colors.lime[600],
          tailwindConfig().theme.colors.sky[600],
        ],
        borderWidth: 0,
      },
    ],
  };

  return (
    <PaziaBox className={className} header="Ogólny bilans" headerLink={headerLink} onAdd={onAdd}>
      <div className="px-5 py-3">
        <div className="mb-2 text-sm italic">Wykres kosztów i przychodów </div>
        <div className={`text-3xl font-bold ${data.balance < 0 ? "text-rose-500" : "text-emerald-500"}`}>
          {toMoneyFormat(data.balance)} zł
        </div>
      </div>
      <PieChart data={chartData} width={389} height={220} />
    </PaziaBox>
  );
};
